import ncsiBackgroundLogo from '../../img/ncsiBackground.png'
import ASRVPcard from './ASRVP-Card';
import { cardStatusType, textStatusType } from '../shared/helpers';
import { useState, useEffect } from 'react';

const ASRVPBackgroundScreening = (props) => {
    const [textBSColor, setTextBSColor] = useState();

    useEffect(() => {
        if(props?.model?.backgroundScreening?.statusColor){
            setTextBSColor(textStatusType(props?.model?.backgroundScreening?.statusColor));
        }
    }, [props]);

    return (
        <>
            <ASRVPcard
                text={<span>
                    If you are in a Registered Volunteer Role, you must complete a background screen every two years.
                    <a className="link" data-bs-toggle="modal" data-bs-target="#rvpRolesModal">View the required RVP Roles here</a>
                </span>}
                image={<img className="asrvp-ncsi-background-logo asrvp-logo" src={ncsiBackgroundLogo} atl="NCSI Background screening solutions" />}
                imageText={"NCSI Background screening solutions"}
                statusText={
                    <div className='asrvp-ncsi-status-text-container'>
                        {!props?.model?.isYouth &&
                            <div>
                                <div className={'text-center fw-bold ' + textBSColor}>
                                    {props?.model?.backgroundScreening?.backgroundMessageLine1}
                                </div>
                                <div className={'text-center fw-bold ' + textBSColor}>
                                    {props?.model?.backgroundScreening?.backgroundMessageLine2}
                                </div>
                                {props?.model?.backgroundScreening?.suspended === false && 
                                <div className={'text-center fw-bold ' + textBSColor}>
                                    {props?.model?.backgroundScreening?.backgroundMessageLine3}
                                </div>}
                                {props?.model?.backgroundScreening?.suspended === true && 
                                <span className={'text-center fw-bold ' + textBSColor}>
                                    {props?.model?.backgroundScreening?.backgroundMessageLine3} <a href="mailto:RegisteredVolunteers@bowl.com?subject=Registered%20Volunteer%20Question" target="_blank" rel="noopener noreferrer">RVP@bowl.com</a>
                                </span>}
                            </div>}
                        {props?.model?.isYouth &&
                            <div>
                                <div className={'text-center fw-bold ' + textBSColor}>
                                    {props?.model?.backgroundScreening?.youthMessageLine1}
                                </div>
                                <div className={'text-center fw-bold ' + textBSColor}>
                                    {props?.model?.backgroundScreening?.youthMessageLine2}
                                </div>
                                <div className={'text-center fw-bold ' + textBSColor}>
                                    {props?.model?.backgroundScreening?.youthMessageLine3}
                                </div>
                                <div className={'text-center fw-bold ' + textBSColor}>
                                    {props?.model?.backgroundScreening?.youthMessageLine4}
                                </div>
                            </div>}
                    </div>
                }
                cardStatusType={cardStatusType(textBSColor)}
            >
                {/* Children */}
                {props?.model?.backgroundScreening?.showBackgroundButton 
                    && (props?.model?.backgroundScreening?.buttonStatus === "Warning")
                    && <a href={props?.model?.backgroundScreening?.backgroundScreeningUrl} type="button" className='btn btn-warning mt-3'>Renew Now</a>}
                {props?.model?.backgroundScreening?.showBackgroundButton 
                    && (props?.model?.backgroundScreening?.buttonStatus === "Danger" )
                    && <a href={props?.model?.backgroundScreening?.backgroundScreeningUrl} type="button" className='btn btn-danger mt-3'>Renew Now</a>}
                {props?.model?.backgroundScreening?.showBackgroundButton 
                    && props?.model?.backgroundScreening?.buttonStatus === "Primary"
                    && <a href={props?.model?.backgroundScreening?.backgroundScreeningUrl} type="button" className='btn btn-primary mt-3'>Background Screening</a>}
            </ASRVPcard>

            <div className="modal fade" id="rvpRolesModal" tabIndex="-1" role="dialog" aria-labelledby="rvpRolesModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title fs-5" id="rvpRolesModalLabel">Registered Volunteer Program Roles</h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <div className="text-start">
                                <label>Who is a required to become a Registered Volunteer?</label>
                            </div>
                            <div className="text-start">
                                Anyone 18 years of age or older who has regular contact or authority over USBC Youth members and those individuals within USBC governance structure. Specific roles or positions within USBC require compliance.
                            </div>
                            <div className="text-start">
                                Those roles are:
                            </div>
                            <div className="text-start">
                                • USBC Headquarters employees
                            </div>
                            <div className="text-start">
                                • USBC National Board and Youth Committee members
                            </div>
                            <div className="text-start">
                                • USBC Team USA and Junior Team USA Members
                            </div>
                            <div className="text-start">
                                • State and Local Youth Committee members and directors
                            </div>
                            <div className="text-start">
                                • State and Local Association Board members
                            </div>
                            <div className="text-start">
                                • State and Local Association Managers
                            </div>
                            <div className="text-start">
                                • USBC league officers in leagues with members age 17 or under
                            </div>
                            <div className="text-start">
                                • USBC Youth tournament managers
                            </div>
                            <div className="text-start">
                                • USBC Trained Coaches
                            </div>
                            <div className="text-start">
                                • USBC SMART Provider
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ASRVPBackgroundScreening;